import React, { useState } from "react";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import InfoDialog from "../infoDialog/InfoDialog";

const InfoSelectWithDialog = ({
  label,
  value,
  onChange,
  infoTitle,
  infoDescription,
  options,
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
        <FormControl fullWidth margin="dense" variant="standard" {...props}>
          <InputLabel>{label}</InputLabel>
          <Select label={label} value={value} onChange={onChange}>
            {options.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {/* Info icon placed outside the FormControl */}
        <IconButton onClick={handleOpen} edge="end" size="small" sx={{ ml: 1 }}>
          <InfoOutlinedIcon fontSize="small" color="action" />
        </IconButton>
      </Box>
      <InfoDialog
        open={open}
        onClose={handleClose}
        title={infoTitle}
        content={infoDescription}
      />
    </>
  );
};

export default InfoSelectWithDialog;
